export default "__VITE_ASSET__DK5bBD$8__"